import { Record } from "immutable";

export default class UserRecord extends Record({
  id: null,
  first_name: "",
  last_name: "",
  vendor_name: "",
  email: "",
  phone: "",
  is_logged_in: false,
  active: true,
  role: "consigner",
  display_staff: null,
  allow_signin: true,
  updatedAt: null,
}) {
  get authenticated() {
    return this.is_logged_in && this.active;
  }

  get fullName() {
    return `${this.first_name} ${this.last_name}`;
  }

  get isVendor() {
    return this.role === "vendor";
  }
}
